<template>
  <div class="landing">
    <section class="heading">
      <h1>ЛУНДАРЬ</h1>
      <h2>Чтобы все получалось</h2>
      <p>Лунный календарь — гороскоп для всех знаков зодиака, который поможет уберечь себя от ошибок, подбирать удачное время для всех своих дел и «поймать» свой собственный ритм жизни.</p>
      <BigButton @clicked="$router.push({ name: 'register' })" >
          {{ $t('register') }}
      </BigButton>
    </section>
    <section>
      <h3>Избегайте неудач</h3>
      <p>Маникюр, сделанный в неудачный день, носится очень плохо, часто даже ломаются ногти, он даже может сокращать время вашей жизни. Если отправиться в путешествие в неподходящее время, то оно принесет проблемы: задержки рейсов, потеря багажа, неудачное поселение в отеле, болезнь или отравление. </p>
      <p>Последствия стрижки в неудачное время приходится исправлять несколько месяцев или даже лет: наново отращивать волосы, выводить неудачно подобранный цвет, лечить волосы. Если первый раз надеть одежду в плохое время, то вещь быстро испортится или просто не будет носиться.</p>
      <p>Приборы, купленные в неудачное время, быстро сломаются или окажутся бесполезными. А если начать лечение в неудачное время, то можно даже усилить болезнь вместо выздоровления.</p>
      <p>Лундарь помогает выбрать подходящее время для каждого дела.</p>
      <BigButton @clicked="$router.push({ name: 'register' })" >
          {{ $t('stop-loosing') }}
      </BigButton>
    </section>
    <section>
      <h3>Индивидуальная благоприятность</h3>
      <p>Лундарь делает все расчеты для вашего города, вашего часового пояса, вашего времени рождения.</p>
      <p>Хотите записаться на стрижку — открываете календарь благоприятности, находите подходящий день, смотрите на благоприятное время и записываетесь к своему парикмахеру. Можете быть уверены, что все «зловредные» факторы уже исключены и ваши глаза и волосы останутся довольными.</p>
      <p>Больше того, Лундарь показывает, какие дни и часы для вас благоприятны, а какие несут опасность. Не «в общем хороши для всех», а благоприятны именно для вас. Это очень важный момент! Часто бывает, что человек делает что-то в «в общем благоприятное время», которое лично для него несет, например, проблемы по здоровью или финансовые потери, и потом разочаровывается в лунном календаре, астрологии и предсказаниях вообще.</p>
      <p>Очень важно учитывать индивидуальную благоприятность. Лундарь в этом вам поможет.</p>
      <BigButton @clicked="$router.push({ name: 'register' })" >
          {{ $t('auspiciousness') }}
      </BigButton>
    </section>
    <section>
      <h3>Не нужно быть астрологом</h3>
      <p>Чтобы пользоваться Лундарем вам нужно знать, что такое календарь, и уметь пользоваться своим смартфоном (или компьютером). Никакие специальные знания не нужны!</p>
      <p>Лундарь — это календарь благоприятностей и прогнозы на каждый день. Благоприятности отмечены иконками с пояснениями, а прогнозы написаны простым понятным языком. В них мы предупреждаем о возможных трудностях или конфликтах, говорим, что в этот день будет хорошо получаться и на что нужно обратить внимание. Общая настройка на день.</p>
    </section>
    <section>
      <h3>Прогнозы помогают понять людей вокруг</h3>
      <p>Бывают дни, когда у всех людей повышена вспыльчивость и агрессивность. В такие дни невозможно ни о чем договориться. Зато поругаться можно буквально на ровном месте.</p>
      <p>Проходит пару дней, и вчерашних агрессоров «хоть к ране прикладывай». Они покладистые, добрые, заботливые, проявляют чудеса эмпатии и готовы носить вас на руках.</p>
      <p>Лундарь поможет вам выбрать хорошее время для важных разговоров и избежать неожиданных конфликтов в общении.</p>
      <BigButton @clicked="$router.push({ name: 'register' })" >
          {{ $t('get-predictions') }}
      </BigButton>
    </section>
    <section>
      <h3>Найти свой собственный ритм</h3>
      <p>Лундарь поможет вам «поймать свою волну». Когда вместо очередной ошибки или борьбы со стеной вы берете паузу, потому что заранее знаете, что ничего хорошего не получится. А на следующий день спокойно и уверенно беретесь за дело и все получается.</p>
      <p>Это дает невероятное чувство уверенности и спокойствия. Исчезает постоянно терзающий вопрос: «Что со мной не так?». Потому что с вами всегда все в порядке, нужно только найти свой ритм, сонастроиться со Вселенной и жить счастливую жизнь.</p>
      <p>Когда у вас все получается, вы перестаете сомневаться в себе, перестаете обесценивать свои умения и таланты, прибавляется творческой энергии в жизни, вы начинаете новые действительно интересные проекты, которые обязательно вырастают во что-то большее. Окружающие начинают видеть в вас эту «заразительную» энергию, начинают вас ценить по-настоящему, хотят быть ближе, хотят помогать, участвовать в ваших делах. Вы возвращаетесь к СВОЕЙ жизни!</p>
      <BigButton @clicked="$router.push({ name: 'register' })" >
          {{ $t('get-rythm') }}
      </BigButton>
    </section>
    <section>
      <h3>Дополнение для астрологов</h3>
      <p>Если вы увлекаетесь астрологией, то для вас в Лундаре есть удобный инструмент — визуальная панчанга. Пять показателей: вара, титхи, накшатра, карана и йога — с детализацией времени, планет-управителей, благоприятности и интуитивной прокруткой по датам.</p>
      <p>Плюс время Раху-Кала и Абхиджит-мухурта для вашего города.</p>
    </section>
  </div>
</template>

<script>
import BigButton from '@/components/visual/BigButton'

export default {
    components: { BigButton },
}
</script>

<i18n locale="ru" lang="yaml">
  login: "Войти"
  register: "Зарегистрироваться"
  stop-loosing: "Перестать ошибаться"
  auspiciousness: "Моя благоприятность"
  get-predictions: "Узнать прогнозы"
  get-rythm: "Найти свой ритм"
</i18n>

<i18n locale="en" lang="yaml">
  login: "Sign in"
  register: "Register"
</i18n>
